var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c('v-toolbar',{attrs:{"color":"white","dark":"","flat":"","dense":"","cad":""}},[_c('v-toolbar-title',{staticClass:"indigo--text"},[_vm._v("Ejecucion de Retorno")])],1)],1)],1),_c('v-layout',[_c('v-flex',[_c('grid-ejecucion',{key:_vm.ejecucionGrid,attrs:{"contratoId":_vm.contratoId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }